"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function LeaderboardIndividualHeader({
  event
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#F6F8FC",
    display: "flex",
    gap: 1,
    paddingX: 2,
    paddingY: 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: 30
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700,
    variant: "body2"
  }, "Pseudo")), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    variant: "body2"
  }, t('commons.challenge_details.table.performance', {
    context: event.challengeTemplate?.type === 'bttf' ? 'bttf' : event.challengeTemplate?.type === 'traveledDistance' ? 'distance' : event.challengeTemplate?.type === 'cyclingDays' ? 'days' : event.challengeTemplate?.type === 'homeWorkJourneysCount' || event.challengeTemplate?.type === 'journeysCount' ? 'journeys' : ''
  }))));
}
var _default = exports.default = LeaderboardIndividualHeader;